<template>
  <div v-show="challengeModal" class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"><b>Start a New Challenge!</b></p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <div>
            <p class="subtitle is-6" align="center">You have selected to challenge {{ opponent.firstName }}</p>
            <p class="subtitle is-6" align="center">{{ opponent.firstName }} holds a rank of {{ opponent.rank }}</p>
            <p class="subtitle is-6" align="center">Please choose your challenge</p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-fullwidth" @click="challengeUser(1); $emit('close')">1 Day Challenge</button>
          <button class="button is-fullwidth" @click="challengeUser(3); $emit('close')">3 Day Challenge</button>
          <!--<button class="button is-fullwidth" @click="$emit('close')">1 Month Challenge</button>-->
          <button class="button is-light is-fullwidth" @click="$emit('close')">Cancel</button>
        </footer>
      </div>
    </div>
</template>

<script>
  import * as firebase from 'firebase'
  import moment from 'moment'

  export default {
    name: 'challengeModal',
    data() {
      return {
        challengeModal: true,
        opponent: {
          id: '',
          email: '',
          firstName: '',
          lastName: '',
          rank: ''
        }
      }
    },
    methods: {
      challengeUser (selectedDuration) {
        let oRank = ''
        if (this.opponent.rank == null || this.opponent.rank == undefined) {
          oRank = 'No Rank'
        } else {
          oRank = this.opponent.rank
        }
        if (this.$store.getters.user.id != this.opponent.id) {
          const challenge = {
            opponentRank: oRank,
            opponentId: this.opponent.id,
            opponentFirstName: this.opponent.firstName,
            opponentHasAccepted: false,
            startDate: '',
            winnerId: '',
            duration: selectedDuration
          }

          this.$store.dispatch('createChallenge', challenge)
          this.challengeModal = false
        } else {
          alert('Error. You can\'t challenge yourself.')
        }
      }
    },
    mounted () {
      // listen for the event when the user is found by email
      this.$root.$on('selectOpponent', foundUser => {
        this.opponent.id = foundUser.id
        this.opponent.firstName = foundUser.firstName
        this.opponent.rank = foundUser.rank
      })
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Challenge/challengeModal.vue